import { useContext, useEffect, useState } from "react";

import LocationContext from "@context/location/locationContext";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";

import { message } from "@src/constants";
import { Flex } from "@shared-ui-components/Flex";
import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import { CustomCardWrapper } from "../HomeDashboard/style";
import CheckSummary from "./CheckSummary";
import CloseCheckTable from "./CheckTable/CloseCheckTable";
import OpenCheckTable from "./CheckTable/OpenCheckTable";
import { getCheckSummaryData, InitialState } from "./helper";
import { TableWrapper } from "./style";

const CheckDashboard = () => {
  const [checkDashboardData, setCheckDashboardData] =
    useState<CheckDashboardSummaryDataType>(InitialState);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [{ locationState }] = useContext(LocationContext);
  const { property, store, revenueCenter, date } = locationState;

  const [{ showErrorToastState, showErrorToastSetState }] = useContext(
    ShowErrorToastContext
  );

  const getData = async (customFilter: FilterType) => {
    try {
      const res = await getCheckSummaryData(customFilter);
      if (!res?.error) {
        setCheckDashboardData(res?.data);
      } else {
        showErrorToastSetState({
          errorMessage: res?.error || "",
          errorTitle: message.ERROR_MESSAGE_DASHBOARD,
          open: true,
        });
      }
    } catch (err) {
      showErrorToastSetState({
        ...showErrorToastState,
        errorTitle: message.ERROR_MESSAGE_DASHBOARD,
        open: true,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const customFilter: FilterType = {
      property,
      store,
      rvc: revenueCenter,
      date,
    };
    getData(customFilter);
  }, [property, store, revenueCenter, date]);

  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;

  return (
    <CustomCardWrapper>
      <CheckSummary
        isLoading={isLoading}
        checkDashboardData={checkDashboardData}
      />
      {isDesktop ? (
        <Flex>
          <TableWrapper>
            <OpenCheckTable />
          </TableWrapper>
          <TableWrapper>
            <CloseCheckTable />
          </TableWrapper>
        </Flex>
      ) : (
        <>
          <OpenCheckTable />
          <CloseCheckTable />
        </>
      )}
    </CustomCardWrapper>
  );
};

export default CheckDashboard;
